import * as React from 'react'
import SesstionTimeout from './SesstionTimeout'
import SettingSessionTimeoutService from '../../services/SettingSessionTimeoutService'


const Timeout = ({onLogout}) => {

    const [activeTimeout, setActiveTimeout] = React.useState(null)
    const [timeout, setTimeout] = React.useState(null)
    const [open, setOpen] = React.useState(false)

    const initial = () => {
        SettingSessionTimeoutService.getItems().then(response=>{
            if(response.success)
            {
                const activeTimeoutData = response.data.find(p=> p.description === 'ActiveTimeout')
                const timeout = response.data.find(p=> p.description === 'Timeout')

                if(activeTimeoutData && timeout)
                {
                    setActiveTimeout({...activeTimeoutData, time: activeTimeoutData.value * 60})
                    setTimeout({...timeout, time: timeout.value * 60})
                    setOpen(true)
                }
            }
        })
    }

    const handleOnLogout = () =>{
        if(typeof onLogout === 'function')
        {
            onLogout();
        }
    }

    React.useEffect(()=>{
        initial();
    },[])

    return <>
        {
            open && <SesstionTimeout onLogout={handleOnLogout} 
            activeTimeOutTime={activeTimeout.time} 
            activeTimeOutCountdown={activeTimeout.countdown} 
            activeTimeOutText={activeTimeout.text}
            limitConnectionTime={timeout.time} 
            limitConnectionCountdown={timeout.countdown} 
            limitConnectionText={timeout.text}
            ></SesstionTimeout>
        }
    </>
}

export default Timeout;
